import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { ToasterService } from 'src/app/services/toaster/toaster.service';
import { TokenService } from 'src/app/services/token/token.service';
import { mobileOrEmailValidator } from './emailormobile.validator';
import { OTPResendTimer } from './otptimer';

enum paswordFieldTypesEnum {
  passwordInputType = 'passwordInputType',
  repeatPasswordInputType = 'repeatPasswordInputType'
}

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss']
})
export class LoginModalComponent implements OnInit, OnDestroy {
  @ViewChild('emailCtrl') emailCtrl!: ElementRef<HTMLInputElement>;
  passwordInputType = 'password';
  repeatPasswordInputType = 'password';
  passwordInputTypes = paswordFieldTypesEnum;
  loginForm: UntypedFormGroup;
  errorMessage = '';
  isResendEnabled = false;
  otpResendTimer = new OTPResendTimer();


  constructor(
    public dialogRef: MatDialogRef<LoginModalComponent>,
    private authServe: AuthService,
    private tokenServe: TokenService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private toasterService: ToasterService,
    private config: ConfigService,
    private loader: LoaderService,
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, mobileOrEmailValidator]],
      password: ['', [Validators.required]],
      rememberMe: [false]
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.otpResendTimer.stopTimer();
  }

  togglePasswordType(variableName: paswordFieldTypesEnum) {
    this[variableName] = this[variableName] === 'text' ? 'password' : 'text';
  }


  getSocialLoginURL(provider = ''): string {
    const url = `${this.config.API_BASE}/oauth2/authorization/${provider}?redirect_uri=${window.location.href}`;
    return url;
  }

  async login(): Promise<void> {
    try {
      this.loginForm.get('email')?.enable();
      const { rememberMe, ...data } = this.loginForm.value;
      this.loginForm.get('email')?.disable();
      this.errorMessage = '';
      this.loader.show();
      const res = await this.authServe.login(data);
      if (res?.user?.roles?.[0] !== 'ROLE_HOST_ADMIN') {
        window.alert(`Only store admins can login to this portal.. You don't have permission !`);
        console.warn(`You (${res?.user?.roles?.[0]}) don't have permission to login to store`);
        return;
      }

      localStorage.setItem('rememberMe', rememberMe)
      this.tokenServe.setLoginData(res);
      if (this.tokenServe.getIsOnBoarded()) {
        this.router.navigate(['/notifications'], { replaceUrl: true });
      } else {
        this.router.navigate(['/profile'], { replaceUrl: true });
      }

      this.dialogRef.close()
    } catch (error: any) {
      this.errorMessage = error?.error?.message;
      console.log(error);
    } finally {
      this.loader.hide();
    }
  }


  openForgotPassword(): void {
    this.dialogRef.close({ openForgotPassword: true });
  }

  validateEmailOrMobile(): void {
    const mobilePatern = new RegExp('^[0-9]{10}$');
    const userName = this.loginForm.get('email')?.value;
    const isMobile = mobilePatern.test(userName);
    if (isMobile) {
      this.loginForm.get('email')?.disable();
      this.sendOTP();
    }
  }

  enableMobileInput(): void {
    this.loginForm.get('email')?.enable();
    this.emailCtrl?.nativeElement?.focus();
    this.otpResendTimer.stopTimer();
    this.errorMessage = '';
  }


  async sendOTP(): Promise<void> {
    try {
      const type = this.isResendEnabled ? 'R' : '';
      this.otpResendTimer.stopTimer();
      this.isResendEnabled = false;
      await this.authServe.sendOTP(this.loginForm.get('email')?.value, type);
      this.errorMessage = '';
      this.toasterService.success('OTP send successful');
      this.otpResendTimer.startTimer(() => {
        this.isResendEnabled = true;
      });
    } catch (error: any) {
      console.log(error);
      this.enableMobileInput();
      this.errorMessage = error?.error?.message;
    }
  }

  openSignUp(): void {
    this.dialogRef.close({ openSignUp: true });
  }

}
